var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown-pressed",
    clipPath: "url(#clip0_1634_2403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.666 11.333L7.99935 4.66634L1.33268 11.333",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1634_2403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0 -1 -1 0 16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownEnabled);
export default __webpack_public_path__ + "static/media/dropdown-enabled.9d8c0d6f8813d57b63ce889bc4c8cba3.svg";
export { ForwardRef as ReactComponent };